import { render } from "./history.vue?vue&type=template&id=09f362cc"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./history.vue?vue&type=style&index=0&id=09f362cc&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__